module.exports = __webpack_public_path__ + "img/ic_memo_allergy.e3895f77.svg";